import React from "react";
import PageTemplate from "../components/PageTemplate";
import MobileSwitcher from "../components/MobileSwitcher";
import EditHeaderMobile from "../components/edit/EditHeaderMobile";
import EditBodyMobile from "../components/edit/EditBodyMobile";
import EditBodyDesktop from "../components/edit/EditBodyDesktop";
import { EditProvider } from "../context/EditSpotlightState";

const Edit = () => {
  return (
    <EditProvider>
      <PageTemplate
        title='Edit Spotlight'
        mobileHeader={<EditHeaderMobile />}
        sidebarTitle={'Change Is Good'}
        sidebarSubtitle='Edit your headline, color, type, etc.'
        centered
      >
        <MobileSwitcher
          mobileComponent={<EditBodyMobile />}
          desktopComponent={<EditBodyDesktop />}
        />
      </PageTemplate>
    </EditProvider>
  );
};

export default Edit;
